// extracted by mini-css-extract-plugin
export var active = "_ji-2";
export var recordingDot = "_ji-1";
export var recordingIndicator = "_ji-0";